import { useMutation as e } from "@maat/store-hooks";
import { adminAiApi as t } from "@maat/api-ai";
//#region src/ai/admin/useSummarizeAiConversationMutation.ts
var n = () => e({ mutationFn: (e) => t.getConversationSummary(e) });
//#endregion
export { n as useSummarizeAiConversationMutation };
